module.exports = __webpack_public_path__ + "img/edit-deactive.edfd7edc.svg";